import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import momentTz from "moment-timezone";
import __ from "lodash";
import { fetch as fetchAirportCosts } from '../../../services/costings/useAirportCosts';
import { fetch as fetchAirport } from '../../../services/airports/useAirports';
import { fetch as fetchCostingFuelRate } from '../../../services/costings/useCostingFuelRate';
import { fetch as fetchExchangeRateConversion } from '../../../services/currencies/useExchangeRateConversion';
import { MaskedNumber } from '../../../controls';
import CountryName from '../../Settings/components/CountryName';
const axios = require('axios');

const acmiTooltip = (sector, sectorIndex, record) => {
  return `$${(record.acmiRate||0).toFixed(2)} x ${sector.blockHours}hrs = $${(sector.acmiCost||0).toFixed(2)}`;
}

const fuelTooltip = (sector, sectorIndex, record) => {
  const {fuelToUplift, fuelPrice} = sector;
  const fuelToUpliftUsg = fuelToUplift/3.04;
  if (fuelToUplift && fuelPrice) {
    return `${fuelToUpliftUsg.toFixed(2)} usg (${fuelToUplift}kg) x ${fuelPrice} = $${(sector.fuelCost||0).toFixed(2)}`;
  }
  return 'No fuel details';
}

const contingencyTooltip = (sector, sectorIndex, record) => {
  const {costFilters} = record;
  let includeFuel = true;
  if (costFilters) {
    if (costFilters?.flightCostDetails?.Fuel && costFilters?.flightCostDetails?.Fuel.length > sectorIndex && costFilters.flightCostDetails.Fuel[sectorIndex] === false) {
      includeFuel = false;
    }
  }
  return (
  <div>
    <div style={{fontWeight: 'bolder', textAlign: 'center'}}>Cost Breakdown</div>
    <div>
      <div style={{display: 'inline-block', width: 200}}>Contingency Hours</div>
      <div style={{display: 'inline-block', width: 50, textAlign: 'right'}}>
        <MaskedNumber 
          displayType="text"
          value={sector.contingencyHoursAmount} 
          prefix="$" 
          decimalScale={2} 
          fixedDecimalScale={true} 
        />
      </div>
    </div>
    {includeFuel &&
    <div>
      <div style={{display: 'inline-block', width: 200}}>Contingency Fuel</div>
      <div style={{display: 'inline-block', width: 50, textAlign: 'right'}}>
        <MaskedNumber 
          displayType="text"
          value={sector.contingencyFuelAmount} 
          prefix="$" 
          decimalScale={2} 
          fixedDecimalScale={true} 
        />
      </div>
    </div>}
  </div>
)}

const permitTooltip = (sector, sectorIndex, record) => {
  const permitDetails = sector.permitDetails;
  const overflightLines = __.filter(permitDetails, {type: 'OVERFLIGHT'});
  const landingLines = __.filter(permitDetails, {type: 'LANDING'});
  const departureLines = __.filter(permitDetails, {type: 'DEPARTURE'});
  if (Array.isArray(permitDetails) && permitDetails.length > 0) {
    return (
      <div>
        <div style={{fontWeight: 'bolder', textAlign: 'center'}}>Cost Breakdown</div>
        {departureLines.length > 0 ?
          <div style={{fontWeight: 'bold', textAlign: 'left', backgroundColor: 'rgba(0,0,0,0.3)'}}>Departure Permits</div>      
          : null
        }
        {departureLines.length > 0 ?
          departureLines.map(line => (
            <div>
              <div style={{display: 'inline-block', width: 200}}><CountryName countryCode={line.countryCode}/></div>
              <div style={{display: 'inline-block', width: 50, textAlign: 'right'}}>
                <MaskedNumber 
                  displayType="text"
                  value={line.cost} 
                  prefix="$" 
                  decimalScale={2} 
                  fixedDecimalScale={true} 
                />
              </div>
            </div>
          ))
          : null
        }
        {landingLines.length > 0 ?
          <div style={{fontWeight: 'bold', textAlign: 'left', backgroundColor: 'rgba(0,0,0,0.3)'}}>Landing Permits</div>      
          : null
        }
        {landingLines.length > 0 ?
          landingLines.map(line => (
            <div>
              <div style={{display: 'inline-block', width: 200}}><CountryName countryCode={line.countryCode}/></div>
              <div style={{display: 'inline-block', width: 50, textAlign: 'right'}}>
                <MaskedNumber 
                  displayType="text"
                  value={line.cost} 
                  prefix="$" 
                  decimalScale={2} 
                  fixedDecimalScale={true} 
                />
              </div>
            </div>
          ))
          : null
        }
        {overflightLines.length > 0 ?
          <div style={{fontWeight: 'bold', textAlign: 'left', backgroundColor: 'rgba(0,0,0,0.3)'}}>Overflight Permits</div>      
          : null
        }
        {overflightLines.length > 0 ?
          overflightLines.map(line => (
            <div>
              <div style={{display: 'inline-block', width: 200}}><CountryName countryCode={line.countryCode}/></div>
              <div style={{display: 'inline-block', width: 50, textAlign: 'right'}}>
                <MaskedNumber 
                  displayType="text"
                  value={line.cost} 
                  prefix="$" 
                  decimalScale={2} 
                  fixedDecimalScale={true} 
                />
              </div>
            </div>
          ))
          : null
        }
      </div>
    );
  }
  return 'No permit details';
}

const navigationTooltip = (sector, sectorIndex, record) => {
  if (!sector.planData || !sector.planData.planText || !Array.isArray(sector.planData.planText)) {
    return `Could not find plan.`;
  }
  const startingLine = sector.planData.planText.indexOf('FIR/UIR Enroute Charge Report...');
  if (startingLine < 0) {
    return `Could not find Charge Report within plan text.`;
  }

  let endingLine = sector.planData.planText.indexOf('END OF JEPPESEN DATAPLAN' , startingLine+1);
  if (endingLine < 0) endingLine = sector.planData.planText.length;

  return (
    <div>
      <div style={{fontWeight: 'bolder', textAlign: 'center'}}>Charge Report</div>
      <div style={{backgroundColor: 'white', padding: 5}}>
        {sector.planData.planText.slice(startingLine, endingLine).map(line => (
          <div style={{fontFamily: 'monospace', color: 'black', fontSize: '0.525rem', whiteSpace: 'pre', padding: 0, margin: 0}}>{line}</div>
        ))}
      </div>
    </div>
  );
}

const costTypes = [
  {code: 'ACMI', name: 'ACMI', fieldName: 'acmiCost', tooltipMethod: acmiTooltip, canEdit: false},
  {code: 'Fuel', name: 'Fuel', fieldName: 'fuelCost', tooltipMethod: fuelTooltip, canEdit: true},
  {code: 'Contingency', name: 'Contingency', fieldName: ['contingencyHoursAmount','contingencyFuelAmount'], extraFieldChecks: {contingencyFuelAmount: 'Fuel'}, tooltipMethod: contingencyTooltip, canEdit: false},
  {code: 'Permits', name: 'Permits', fieldName: 'permitCosts', tooltipMethod: permitTooltip, canEdit: true},
  {code: 'Navigation', name: 'Navigation Fees', fieldName: 'overflightCost', tooltipMethod: navigationTooltip, canEdit: true},
];

const defaultCostFilters = {
  ACMI: true,
  Fuel: true,
  Contingency: true,
  Permits: true,
  Navigation: true,
  FlightSectors: [], 
  flightCostDetails: {
    ACMI: [], 
    Fuel: [], 
    Contingency: [], 
    Permits: [], 
    Navigation: [], 
  },
  GroundCosts: true,
  groundCostDetails: {
    categoryGroups: [],
    categories: [],
    airports: [],
  },
}

const totalFields = (costType, sector, sectorIndex, costFilters) => {
  let total = 0;
  let fieldNames = Array.isArray(costType.fieldName)?costType.fieldName:[costType.fieldName];
  for (let i = 0; i < fieldNames.length; i++) {
    let includeInTotal = true;
    if (costFilters) {
      const {flightCostDetails} = costFilters;
      if (costType.extraFieldChecks) {
        const extraCode = costType.extraFieldChecks[fieldNames[i]];
        if (extraCode && flightCostDetails[extraCode] && flightCostDetails[extraCode].length > sectorIndex && flightCostDetails[extraCode][sectorIndex] === false) {
          includeInTotal = false;
        }
      }
    }  
    let cost = sector[fieldNames[i]] || 0;
    if (includeInTotal) total += cost;  
  }
  return total;
}

const getGrandTotals = (sectors, costTypes, costFilters) => {
  let totals = new Array(sectors.length);
  totals.fill(0);
  let grandTotal = 0;
  for (let i = 0; i < sectors.length; i++) {
    const sector = sectors[i];
    for (let j = 0; j < costTypes.length; j++) {
      if (costFilters['flightCostDetails'][costTypes[j].code][i] !== true) continue;
      let cost = totalFields(costTypes[j], sector, i, costFilters) || 0;
      totals[i] += cost;  
      grandTotal += cost;
    }
  }
  totals.push(grandTotal);
  return totals;
}

const getCostTypeForField = (fieldName) => {
  const costType = costTypes.find(costType => {
    if (Array.isArray(costType.fieldName)) return costType.fieldName.includes(fieldName);
    return costType.fieldName === fieldName;
  });
  return costType;
}

const checkDate = (sector, direction, days, validTimeFrom, validTimeTo, timeZone)  => {
  if (!direction || direction === "NA") return true;

  let valid = true;
  const sectorDate = direction === 'IN'?sector.scheduledArrivalTimeUTC:sector.scheduledDepartureTimeUTC;

  const localTime = sectorDate?moment.utc(sectorDate).tz(timeZone).format("HH:mm"):'12:00';
  const localDay = sectorDate?moment.utc(sectorDate).tz(timeZone).isoWeekday():1;
  
  if (typeof days === 'string') {
    if (days.indexOf(`${localDay}`) < 0) {
      valid = false;
    }
  }
  if (validTimeFrom && validTimeTo) {
    let fromTime = validTimeTo > validTimeFrom ? `2000-01-02 ${validTimeFrom}` : `2000-01-01 ${validTimeFrom}`;
    let toTime = `2000-01-02 ${validTimeTo}`;

    let date = localTime > validTimeTo ? `2000-01-01 ${localTime}` : `2000-01-02 ${localTime}`;

    if (moment(date).isBefore(fromTime) || moment(date).isAfter(toTime)) {
      valid = false;
    }
  }

  return valid;
}

const checkCargoHandling = (cargoHandlingType, payloadUp, payloadOff)  => {
  let noCargoHandling = payloadUp <= 0 && payloadOff <= 0;
  let loading = payloadUp > 0;
  let unloading = payloadOff > 0;
  let onlyLoading = payloadUp > 0 && payloadOff <= 0;
  let onlyUnloading = payloadOff > 0 && payloadUp <= 0;
  let both = payloadUp > 0 && payloadOff > 0;
  let some = payloadUp > 0 || payloadOff > 0;

  if (cargoHandlingType === 'ANY' && some) return true;
  if (cargoHandlingType === 'BOTH' && both) return true;
  if (cargoHandlingType === 'NONE' && noCargoHandling) return true;
  if (cargoHandlingType === 'LOADING' && loading) return true;
  if (cargoHandlingType === 'UNLOADING' && unloading) return true;
  if (cargoHandlingType === 'LOADING ONLY' && onlyLoading) return true;
  if (cargoHandlingType === 'UNLOADING ONLY' && onlyUnloading) return true;

  if (!cargoHandlingType) return true;
  return false;
}

const buildRoutes = (legs) => {
  const routes = [];
  let routeLegs = __.filter(legs, {transportType: 'PRIMARY'});
  const primaryLegs = __.filter(legs, {transportType: 'PRIMARY'});
  const otherLegs = __.filter(legs, (leg) => leg.transportType !== 'PRIMARY');
  for (let i = 0; i < otherLegs.length; i++) {
    let leg = otherLegs[i];
    let {originAirportCode, destinationAirportCode} = leg;
    let originInRoute = __.findIndex(primaryLegs, {destinationAirportCode: originAirportCode});
    let destinationInRoute = __.findIndex(primaryLegs, {originAirportCode: destinationAirportCode});
    if (originInRoute > -1) {
      routeLegs.push(leg);
    } else if (destinationInRoute > -1) {
      routeLegs.splice(0,0,leg);
    }
  }
  const followRoute = (airportCode, offset, route) => {
    let found = false;
    for (let i = offset; i < routeLegs.length; i++) {      
      const {originAirportCode, destinationAirportCode} = routeLegs[i];
      if (originAirportCode === airportCode && route.indexOf(airportCode) < 0) {
        found = true;
        routes.push([...route, airportCode]);
        followRoute(destinationAirportCode, i, [...route, airportCode])
      }
    }
    if (!found && route.indexOf(airportCode) < 0) {
      routes.push([...route, airportCode]);
    }
  }
  for (let i = 0; i < routeLegs.length; i++) {
    const route = [];
    const {originAirportCode, destinationAirportCode} = routeLegs[i];
    route.push(originAirportCode);
    // route.push(destination);
    followRoute(destinationAirportCode, i, route);
  }
  return routes;
}

const getOriginCode = (legs, originAirportCode, destinationAirportCode) => {
  const index = __.findIndex(legs, {originAirportCode, destinationAirportCode});
  return `${originAirportCode}-${index}`;
}

const getDestinationCode = (legs, originAirportCode, destinationAirportCode) => {
  const index = __.findIndex(legs, {originAirportCode, destinationAirportCode});
  return `${destinationAirportCode}-${index + 1}`;
}

// const findCargoAirportPositions = (originAirportCode, destinationAirportCode, legs) => {
//   const sectors = legs.length > 0 ? [`${legs[0].originAirportCode}-0`, ...legs.map((leg,i) => `${leg.destinationAirportCode}-${(i + 1)}`)] : [];
//   const airports = legs.length > 0 ? [`${legs[0].originAirportCode}`, ...legs.map((leg) => `${leg.destinationAirportCode}`)] : [];

//   let originPosition = 0;
//   let destinationPosition = 0;

//   const origins = __.filter(sectors, airportPlusIdx => {
//     const [airportCode, idx] = airportPlusIdx.split('-');
//     return (airportCode === originAirportCode);
//   })

//   const destinations = __.filter(sectors, airportPlusIdx => {
//     const [airportCode, idx] = airportPlusIdx.split('-');
//     return (airportCode === destinationAirportCode);
//   })

//   const foundExtraAirport = (idx, idx2, originAirportCode, destinationAirportCode) => {
//     for (let x = (idx + 1); x < (idx2 - 1); x++) {
//       if (airports[x] === originAirportCode || airports[x] === destinationAirportCode) return true;
//     }
//     return false;
//   }
//   for (let i = 0; i < origins.length && !originPosition; i++) {
//     const [originAirportCode, index1] = origins[i].split('-');
//     for ( let j = 0; j < destinations.length && !destinationPosition; j++) {
//       const [destinationAirportCode, index2] = destinations[j].split('-');

//       const idx = parseInt(index1);
//       const idx2 = parseInt(index2);

//       if (idx && idx2 && idx2 > idx && !foundExtraAirport(idx, idx2, originAirportCode, destinationAirportCode)) {
//         originPosition = idx;
//         destinationPosition = idx2;
//       }
//     }
//   }

//   return {originPosition, destinationPosition};
// }

const getCargoData = (legs, cargo) => {

  const routes = buildRoutes(legs);

  const buildup = {};
  const breakdown = {};
  const loading = {};
  const unloading = {};
  const bupLoading = {};
  const bupUnloading = {};
  const bupLoadingCount = {};
  const bupUnloadingCount = {};
  const handledBupLoading = {};
  const handledBupCountLoading = {};
  const handledBupUnloading = {};
  const handledBupCountUnloading = {};
  const unsecureLoose = {};
  const unsecureBup = {};
  const unsecureBupCount = {};
  const inboundTrucking = {};
  const outboundTrucking = {};
  const payloadsUp = {};
  const payloadsOff = {};

  for (let i = 0; i < cargo.length; i++) {
    let {originAirportCode, destinationAirportCode, payloadLoose, payloadUnitised, bupCount, includeHandling, cargoSecure, payloadUld} = cargo[i];
    if (!payloadLoose) {
      payloadLoose = 0;
    }
    if (!payloadUnitised) {
      payloadUnitised = 0;
    }
    if (!payloadUld) {
      payloadUld = 0;
    }

    const cargoRoute = __.find(routes, (route) => route[0] === originAirportCode && route[route.length - 1] === destinationAirportCode);
    if (!cargoRoute) {
      console.log(`Unable to find route for cargo going from ${originAirportCode} to ${destinationAirportCode}`);
      continue;
    }

    let primaryLegs = [];
    let otherLegs = [];
    for (let r = 0; r < cargoRoute.length - 1; r++) {
      const origin = cargoRoute[r];
      const destination = cargoRoute[r + 1];

      const leg = __.find(legs, {originAirportCode: origin, destinationAirportCode: destination});
      if (leg) {
        if (leg.transportType === 'PRIMARY') {
          primaryLegs.push(leg);
        } else {
          otherLegs.push(leg);
        }
      }
    }

    const origin = getOriginCode(legs, primaryLegs[0].originAirportCode, primaryLegs[0].destinationAirportCode);
    const destination = getDestinationCode(legs, primaryLegs[primaryLegs.length - 1].originAirportCode, primaryLegs[primaryLegs.length - 1].destinationAirportCode);

    const originLeg = `${primaryLegs[0].originAirportCode}-${primaryLegs[0].destinationAirportCode}`;
    const destinationLeg = `${primaryLegs[primaryLegs.length - 1].originAirportCode}-${primaryLegs[primaryLegs.length - 1].destinationAirportCode}`;

    if (!__.has(payloadsUp, originLeg)) payloadsUp[originLeg] = 0;
    if (!__.has(payloadsOff, destinationLeg)) payloadsOff[destinationLeg] = 0;

    payloadsUp[originLeg] += (payloadLoose + payloadUnitised + payloadUld);
    payloadsOff[destinationLeg] += (payloadLoose + payloadUnitised + payloadUld); 

    if (origin) {
      if (!__.has(buildup, origin)) buildup[origin] = 0;
      if (!__.has(loading, origin)) loading[origin] = 0;
      if (!__.has(bupLoading, origin)) bupLoading[origin] = 0;
      if (!__.has(bupLoadingCount, origin)) bupLoadingCount[origin] = 0;
      if (!__.has(handledBupLoading, origin)) handledBupLoading[origin] = 0;
      if (!__.has(handledBupCountLoading, origin)) handledBupCountLoading[origin] = 0;
      if (!__.has(unsecureLoose, origin)) unsecureLoose[origin] = 0;
      if (!__.has(unsecureBup, origin)) unsecureBup[origin] = 0;
      if (!__.has(unsecureBupCount, origin)) unsecureBupCount[origin] = 0;
      loading[origin] += (payloadLoose + payloadUnitised); 
      bupLoading[origin] += payloadUnitised; 
      bupLoadingCount[origin] += bupCount; 
      if (includeHandling) {
        buildup[origin] += payloadLoose;
        handledBupLoading[origin] += bupCount; 
        handledBupLoading[origin] += payloadUnitised; 
        handledBupCountLoading[origin] += bupCount; 
        if (!cargoSecure) {
          unsecureLoose[origin] += payloadLoose;
          unsecureBup[origin] += payloadUnitised; 
          unsecureBupCount[origin] += bupCount; 
        }
      }
    }
    
    if (destination) {
      if (!__.has(breakdown, destination)) breakdown[destination] = 0;
      if (!__.has(unloading, destination)) unloading[destination] = 0;
      if (!__.has(bupUnloading, destination)) bupUnloading[destination] = 0;
      if (!__.has(bupUnloadingCount, destination)) bupUnloadingCount[destination] = 0;
      if (!__.has(handledBupUnloading, destination)) handledBupUnloading[destination] = 0;
      if (!__.has(handledBupCountUnloading, destination)) handledBupCountUnloading[destination] = 0;
      unloading[destination] += (payloadLoose + payloadUnitised); 
      bupUnloading[destination] += payloadUnitised; 
      bupUnloadingCount[destination] += bupCount; 
      if (includeHandling) {
        breakdown[destination] += payloadLoose;
        handledBupUnloading[destination] += payloadUnitised; 
        handledBupCountUnloading[destination] += bupCount; 
      }
    }
  
    for (let o = 0; o < otherLegs.length; o++) {
      const leg = otherLegs[o];
      const {originAirportCode, destinationAirportCode} = leg;
      const payloadLeg = `${originAirportCode}-${destinationAirportCode}`;
      if (!__.has(payloadsUp, payloadLeg)) payloadsUp[payloadLeg] = 0;
      if (!__.has(payloadsOff, payloadLeg)) payloadsOff[payloadLeg] = 0;

      payloadsUp[payloadLeg] += (payloadLoose + payloadUnitised + payloadUld);
      payloadsOff[payloadLeg] += (payloadLoose + payloadUnitised + payloadUld); 

      if (leg.transportType === 'TRUCK') {
        if (destinationAirportCode === primaryLegs[0].originAirportCode) {
          if (!__.has(inboundTrucking, origin)) inboundTrucking[origin] = 0;
          inboundTrucking[origin] += (payloadLoose + payloadUnitised + payloadUld);
        } else {
          if (!__.has(outboundTrucking, destination)) outboundTrucking[destination] = 0;
          outboundTrucking[destination] += (payloadLoose + payloadUnitised + payloadUld);
        }
      }
    }

  }

  return {buildup, breakdown, loading, unloading, bupLoading, bupLoadingCount, bupUnloading, bupUnloadingCount, handledBupLoading, handledBupCountLoading, handledBupUnloading, handledBupCountUnloading, unsecureLoose, unsecureBup, unsecureBupCount, payloadsUp, payloadsOff, inboundTrucking, outboundTrucking }
};

const rebuildPayloads = (legs, cargo) => {
  const {payloadsUp, payloadsOff} = getCargoData(legs, cargo);
  let remaining = 0;
  for (let i = 0; i < legs.length; i++) {
    let leg = legs[i];
    let {originAirportCode, destinationAirportCode} = leg;
    const payloadLeg = `${originAirportCode}-${destinationAirportCode}`;

    let payloadUp = __.has(payloadsUp, payloadLeg)?payloadsUp[payloadLeg]:0;
    let payloadOff = __.has(payloadsOff, payloadLeg)?payloadsOff[payloadLeg]:0;
    let payloadRemaining = remaining;
    let onboard = remaining + payloadUp;
    remaining = onboard - payloadOff;  
    leg['payloadUp'] = payloadUp;
    leg['payloadOnboard'] = onboard;
    leg['payloadOff'] = payloadOff;
    leg['payloadRemaining'] = payloadRemaining;
  }

  return {legs, cargo}
}

const calculateRevenue = (sector, contingencyBlockHoursRate) => {
  let revenueAmount = 0;

  if (sector.revenueCalculationMethod === 'COST PLUS') {
    revenueAmount = sector.totalCost + sector.revenueCalculationAmount;
  }
  if (sector.revenueCalculationMethod === 'PERCENT UPLIFT') {
    revenueAmount = sector.totalCost + (Math.round((sector.totalCost * (sector.revenueCalculationAmount / 100))*100) / 100);
  }
  if (sector.revenueCalculationMethod === 'MARKET') {
    revenueAmount = (sector.revenueCalculationAmount * (sector.payloadOnboard));
  }
  if (sector.revenueCalculationMethod === 'PER KG') {
    revenueAmount = (sector.revenueCalculationAmount * (sector.payloadOnboard));
  }
  if (sector.revenueCalculationMethod === 'ACMI ONLY') {    
    revenueAmount = (sector.revenueCalculationAmount * (sector.blockHours));
    revenueAmount = revenueAmount + Math.round((revenueAmount * 100 * ((contingencyBlockHoursRate||0) / 100)))/100;
  }
  if (sector.revenueCalculationMethod === 'ACMI PLUS') {
    let acmiCost = sector.revenueCalculationAmount * (sector.blockHours);
    acmiCost = acmiCost + Math.round((acmiCost * 100 * ((contingencyBlockHoursRate||0) / 100)))/100;
    revenueAmount = (acmiCost + (sector.totalCost - (sector.acmiCost + sector.contingencyHoursAmount)));
  }
  if (sector.revenueCalculationMethod === 'VALUE') {
    revenueAmount = sector.revenueCalculationAmount;
  }

  return revenueAmount;
}

const rebuildRevenue = (legs, contingencyBlockHoursRate) => {
  const newLegs = __.cloneDeep(legs);
  for (let i = 0; i < newLegs.length; i++) {
    const revenueAmount = calculateRevenue(newLegs[i], contingencyBlockHoursRate);
    newLegs[i]['revenueAmount'] = revenueAmount;
  }

  return newLegs;
}

const getCargoDataForAirport = (cargoData, code) => {
  const airportCargoData = {
     buildup: 0,
     breakdown: 0,
     loading: 0,
     unloading: 0,
     bupLoading: 0,
     bupUnloading: 0,
     bupLoadingCount: 0,
     bupUnloadingCount: 0,
     handledBupLoading: 0,
     handledBupCountLoading: 0,
     handledBupUnloading: 0,
     handledBupCountUnloading: 0,
     unsecureLoose: 0,
     unsecureBup: 0, 
     unsecureBupCount: 0,
     inboundTrucking: 0,
     outboundTrucking: 0, 
  }

  Object.keys(airportCargoData).forEach(key => {
    if (__.has(cargoData, key) && __.has(cargoData[key], code)) {
      airportCargoData[key] = cargoData[key][code];
    }
  });

  return airportCargoData;
}

const getUsdPrice = async (currencyCode, currencyPrice, costingDate, queryClient) => {
  if (currencyCode === 'USD') return {price: currencyPrice, fromCurrencySymbol: '$', toCurrencySymbol: '$', exchangeRate: 1};

  const extraKeys = [
    "SYSTEM",
    currencyCode || "USD",
    "USD",
    moment.utc(costingDate).format("YYYY-MM-DD") || "0001-01-01",
  ];

  const conversion = await fetchExchangeRateConversion({extraKeys, queryClient});
  const {fromCurrencySymbol, toCurrencySymbol, conversionFactor} = conversion;
  const rate = conversionFactor||0;
  const price = currencyPrice * rate;

  return {price, fromCurrencySymbol, toCurrencySymbol, exchangeRate: rate};
}

const calculateLineCost = (sector, costCategoryLine, categoryCost, cargoData, overrides, fromCurrencySymbol, price, exchangeRate) => {
  const {costCategoryUuid, costCategoryLineUuid, found, calculationType, calculationUnitType, cargoHandlingType, cargoType, days, freeQuantity, lineName, minimumQuantity, validTimeFrom, validTimeTo, direction, timeZone, timings, currencyCode, price: currencyPrice} = costCategoryLine;
  const {code, airportCode, payloadUp, payloadOnboard, payloadOff, type} = sector;

  const {buildup, breakdown, loading, unloading, bupLoading, bupUnloading, bupLoadingCount, bupUnloadingCount, handledBupLoading, handledBupCountLoading, handledBupUnloading, handledBupCountUnloading, unsecureLoose, unsecureBup, unsecureBupCount, inboundTrucking, outboundTrucking } = getCargoDataForAirport(cargoData, code);

  const {overrideQuantity, overrideCost, valueEntryType, overrideCostInbound, overrideCostOutbound} = {overrideQuantity: null, overrideCost: null, valueEntryType: null, overrideCostInbound: null, overrideCostOutbound: null,...overrides};

  let cost = 0;
  let usePercentage = false;
  let calculationQuantity = 0;
  if (overrideQuantity !== null && !isNaN(overrideQuantity)) {
    calculationQuantity = overrideQuantity;
  }
  let calculationText = "";

  if (calculationQuantity || (checkCargoHandling(cargoHandlingType, loading, unloading) && checkDate(sector, direction, days, validTimeFrom, validTimeTo, timeZone))) {
    let qty = 0;
    let ignoreMinimum = false;


    let found = false;

    let suffix = "";
    let currencySymbol = "$";

    switch (calculationType) {
      case 'PER_KG':
        suffix = "kg";
        qty = payloadOnboard;
        if (calculationUnitType === 'LOADED' || (!calculationUnitType && (cargoHandlingType === 'LOADING' || cargoHandlingType === 'LOADING ONLY'))) {
          qty = payloadUp;
          found = true;
        }
        if (calculationUnitType === 'UNLOADED' || (!calculationUnitType && (cargoHandlingType === 'UNLOADING' || cargoHandlingType === 'UNLOADING ONLY'))) {
          qty = payloadOff;
          found = true;
        }
        if (calculationUnitType === 'BUILDUP') {
          qty = buildup;
          found = true;
        }
        if (calculationUnitType === 'BREAKDOWN') {
          qty = breakdown;
          found = true;
        }
        if (calculationUnitType === 'LOADING LOOSE') {
          qty = loading;
          found = true;
        }
        if (calculationUnitType === 'LOADING BUP') {
          qty = bupLoading;
          found = true;
        }
        if (calculationUnitType === 'UNLOADING LOOSE') {
          qty = unloading;
          found = true;
        }
        if (calculationUnitType === 'UNLOADING BUP') {
          qty = bupUnloading;
          found = true;
        }
        if (calculationUnitType === 'HANDLED BUP OUTBOUND') {
          qty = handledBupLoading;
          found = true;
        }
        if (calculationUnitType === 'HANDLED BUP INBOUND') {
          qty = handledBupUnloading;
          found = true;
        }
        if (calculationUnitType === 'UNSECURE LOOSE') {
          qty = unsecureLoose;
          found = true;
        }
        if (calculationUnitType === 'UNSECURE BUP') {
          qty = unsecureBup;
          found = true;
        }
        if (calculationUnitType === 'UNSECURE') {
          qty = unsecureLoose + unsecureBup;
          found = true;
        }
        if (calculationUnitType === 'INBOUND TRUCKING') {
          qty = inboundTrucking;
          found = true;
        }
        if (calculationUnitType === 'OUTBOUND TRUCKING') {
          qty = outboundTrucking;
          found = true;
        }
        if (valueEntryType === 'WEIGHT' && !found) {
          qty = 0;
          found = true;
        }
      break;
      case 'PER_HOUR':
        suffix = "hr(s)";
        qty = 0;
        if (calculationUnitType === 'ARRIVAL TURNAROUND' || (calculationUnitType === 'TURNAROUND' && type !== 'START')) {
          let band = '0';
          if (payloadOff === 0) {
            band = '0';
          }
          if (payloadOff > 0) {
            band = '50';
          }
          if (payloadOff > 50000) {
            band = '100';
          }
          const timing = __.find(timings || [], {outbound: 0, cargoProfileCode: band});
          if (timing) {
            qty += Math.round(timing.durationMinutes * 10 / 60) / 10;
            found = true;
          }
        }
        if (calculationUnitType === 'DEPARTURE TURNAROUND' || (calculationUnitType === 'TURNAROUND' && type !== 'END')) {
          let band = '0';
          if (payloadUp === 0) {
            band = '0';
          }
          if (payloadUp > 0) {
            band = '50';
          }
          if (payloadUp > 50000) {
            band = '100';
          }
          const timing = __.find(timings || [], {outbound: 1, cargoProfileCode: band});
          if (timing) {
            qty += Math.round(timing.durationMinutes * 10 / 60) / 10;
            found = true;
          }
        }
        if (valueEntryType === 'HOURS' && !found) {
          qty = 0;
          found = true;
        }
      break;
      case 'PER_PALLET':
        if (calculationUnitType === 'LOADED') {
          qty = bupLoadingCount;
          found = true;
        }
        if (calculationUnitType === 'UNLOADED') {
          qty = bupUnloadingCount;
          found = true;
        }
        if (calculationUnitType === 'HANDLED OUTBOUND') {
          qty = handledBupCountLoading;
          found = true;
        }
        if (calculationUnitType === 'HANDLED INBOUND') {
          qty = handledBupCountUnloading;
          found = true;
        }
        if (calculationUnitType === 'UNSECURE') {
          qty = unsecureBupCount;
          found = true;
        }
        if (valueEntryType === 'ULDS' && !found) {
          qty = 0;
          found = true;          
        }
      break;
      case 'PER_SERVICE':
        qty = 1;
        found = true;
        break;
      case 'PER_AIRPORT':
        qty = 1;
        found = true;
        break;
      case 'PER_DEPARTURE': 
        if (type !== 'END') {
          qty = 1;  
          found = true;
        } else {
          // ignoreMinimum = true;
        }
      break;
      case 'PER_LANDING': 
        if (type !== 'START') {
          qty = 1;
          found = true;
        } else {
          // ignoreMinimum = true;
        }
      break;
      case 'PERCENTAGE_OF_COST':
        usePercentage = true;
        price = currencyPrice;
        found = true;
      break;
      default: 
        qty = 0;
        // ignoreMinimum = true;
      break;
    }
    if (usePercentage) {
      cost = (categoryCost * price) / 100;
      calculationText = `${categoryCost}${suffix} @ ${price}%`
    } else {
      let priceText = `${currencySymbol}${price.toLocaleString('en-GB')}`;
      if (currencyCode !== 'USD') {
        priceText += ` (${fromCurrencySymbol}${currencyPrice.toLocaleString('en-GB')} ${currencyCode})`;         
      }
      calculationText = `${qty}${suffix} x ${priceText}`;
      const minQty = ignoreMinimum?qty:((qty > minimumQuantity) && found)?qty:minimumQuantity;
      if (minQty !== qty) {
        calculationText = `${minQty}${suffix} (minimum qty applied) x ${priceText}`;
      }
      calculationQuantity =  (minQty > freeQuantity? minQty - freeQuantity : 0);  
      if (minQty !== qty && calculationQuantity !== minQty) {
        calculationText = `${calculationQuantity}${suffix} (minimum and free qty applied) x ${priceText}`;
      } else if (minQty !== calculationQuantity) {
        calculationText = `${calculationQuantity}${suffix} (free qty applied) x ${priceText}`;
      }
      if (overrideQuantity !== null && !isNaN(overrideQuantity)) {
        calculationQuantity = overrideQuantity;
        calculationText = `${calculationQuantity}${suffix} (quantity changed) x ${priceText}`;
      }
      cost = price * calculationQuantity;
    }
  }
  // if (overrideCost !== null && !isNaN(overrideCost)) {
  //   cost = overrideCost;
  //   calculationText = "";
  // }
  return {cost, qty: calculationQuantity, percent: usePercentage?price:0, calculationText, found};
} 

const initialiseAirportCost = async (queryClient, category, services, aircraftReg, sector, cargoData, overrides, costingDate) => {
  const {airportCode, code, type} = sector;
  const {costCategoryUuid, autoSelect} = category;
  let defaultCost = 0;
  let totalInboundCost = 0;
  let totalOutboundCost = 0;
  let costBreakdown = [];
  let airportCostFound = false;
  
  const service = __.find(services, {costCategoryUuid: costCategoryUuid});
  const costRecordAirports = service?.costRecordAirports||[];
  let oldCosts = __.find(costRecordAirports, {code, changed: true});
  const extraKeys = [airportCode, aircraftReg, costCategoryUuid];
  try {
    const airportCosts = await fetchAirportCosts({queryClient, extraKeys, useCache: true});  
    let quantity = 0;
    let error = false;
    if (Array.isArray(airportCosts) && airportCosts.length > 0) {
      airportCostFound = true;
      for (let i = 0; i < airportCosts.length; i++) {
        const costCategoryLine = airportCosts[i];
        const {lineName, costCategoryLineUuid, costAllocationInboundPercentage, costAllocationOutboundPercentage, found, price: currencyPrice, currencyCode} = costCategoryLine;
        const {fromCurrencySymbol, price, exchangeRate} = await getUsdPrice(currencyCode, currencyPrice, costingDate, queryClient, );
        error = {hasAirportCost: found || false};
        if (!found) {
          if (__.has(costCategoryLine, 'validFrom') && __.has(costCategoryLine, 'validTo')) {
            const {validFrom, validTo} = costCategoryLine;
            if (validFrom === null || validTo === null) {
              error = {...error, validityPeriodMissing: true};
            } else {
              if (moment(validFrom).diff(moment(costingDate), 'days') < 0) {
                error = {...error, validityExpired: true, validFrom, validTo};
              }
            }
          } else {
            error = {...error, validityPeriodMissing: true};
          }
        }
        if (error && error.found && !error.validityPeriodMissing && !error.validityPeriodMissing) error = false;
        let inPercent = 50;
        let outPercent = 50;
        if (costAllocationInboundPercentage) {
          inPercent = costAllocationInboundPercentage;
          outPercent = 100 - costAllocationInboundPercentage;
        } else if (costAllocationOutboundPercentage) {
          inPercent = 100 - costAllocationOutboundPercentage;
          outPercent = costAllocationOutboundPercentage;
        }
        let cost = 0, qty = 0, percent = 0, calculationText="";
        const data = calculateLineCost(sector, costCategoryLine, defaultCost, cargoData, overrides, fromCurrencySymbol, price, exchangeRate);
        cost = data.cost;
        qty = data.qty; 
        percent = data.percent;
        calculationText = data.calculationText;

        if (i === 0) quantity = qty;
        let lineCost = cost;
        let inboundCost = lineCost && inPercent ? lineCost * (inPercent / 100): 0;
        let outboundCost = lineCost && outPercent ? lineCost * (outPercent /100): 0;

        if (type === 'START') {
          lineCost = outboundCost;
          inboundCost = 0;
          if (lineCost !== cost) calculationText += ` @ ${outPercent}%`
        }
        if (type === 'END') {
          lineCost = inboundCost;
          outboundCost = 0;
          if (lineCost !== cost) calculationText += ` @ ${inPercent}%`
        }

        defaultCost += lineCost;
        totalInboundCost += inboundCost;
        totalOutboundCost += outboundCost;
        if (lineCost > 0) {
          costBreakdown.push({lineName, lineCost, cost, costCategoryLineUuid, qty, percent, calculationText});
        }

      }
    }
    const defaultInboundCost = totalInboundCost;
    const defaultOutboundCost = totalOutboundCost; 
    if (__.has(overrides, 'overrideCost') && overrides.overrideCost !== null && !isNaN(overrides.overrideCost)){
      return {code, airportCode, defaultSelected: autoSelect, defaultCost, defaultInboundCost, defaultOutboundCost, defaultCostBreakdown: costBreakdown, defaultQuantity: quantity, totalInboundCost: overrides.overrideCostInbound, totalOutboundCost: overrides.overrideCostOutbound, selected: autoSelect, cost: overrides.overrideCost, costBreakdown, selectedinitialised: true, changed: true, quantity, error, airportCostFound, useCost: overrides.useCost || false};
    }

    return {code, airportCode, defaultSelected: autoSelect, defaultCost, defaultInboundCost, defaultOutboundCost, defaultCostBreakdown: costBreakdown, defaultQuantity: quantity, totalInboundCost: autoSelect?defaultInboundCost:0, totalOutboundCost: autoSelect?defaultOutboundCost:0, selected: autoSelect, cost: autoSelect?defaultCost:0, costBreakdown, selectedinitialised: true, changed: false, quantity, error, ...oldCosts, airportCostFound, useCost: false};
  } catch (err) {
    return {code, airportCode, defaultSelected: autoSelect, defaultCost: 0, defaultInboundCost: 0, defaultOutboundCost: 0, defaultCostBreakdown: null, defaultQuantity: 0, totalInboundCost: null, totalOutboundCost: null, selected: autoSelect, cost: 0, costBreakdown: null, selectedinitialised: true, changed: false, quantity: 0, ...oldCosts, error: {error: err}, failed: true, airportCostFound: false, useCost: false};
  }
}

function buildSectorsAirportData(legs) {
  const primaryLegs = __.filter(legs, { transportType: 'PRIMARY' });
  const otherLegs = __.filter(legs, leg => leg.transportType !== 'PRIMARY');
  const sectorAirportsData = primaryLegs.length > 0 ? [
    ...primaryLegs.map((leg, i) => {
      return {
        code: getOriginCode(legs, leg.originAirportCode, leg.destinationAirportCode),
        airportCode: leg.originAirportCode,
        type: i === 0 ? 'START' : 'MIDDLE',
        payloadUp: leg.payloadUp,
        payloadOnboard: leg.payloadOnboard,
        payloadOff: i === 0 ? 0 : primaryLegs[i - 1].payloadOff
      };
    }), {
      code: getDestinationCode(legs, primaryLegs[primaryLegs.length - 1].originAirportCode, primaryLegs[primaryLegs.length - 1].destinationAirportCode),
      airportCode: primaryLegs[primaryLegs.length - 1].destinationAirportCode,
      type: 'END',
      payloadOff: primaryLegs[primaryLegs.length - 1].payloadOff,
      payloadUp: 0,
      payloadOnboard: 0
    }
  ] : [];
  return { sectorAirportsData, primaryLegs, otherLegs };
}

function rebuildLegTotals(primaryLegs, newServices, contingencyFuelCostRate, contingencyBlockHoursRate, costFilters) {
  // const costTypes = [
  //   'acmiCost',
  //   'fuelCost',
  //   'permitCosts',
  //   'overflightCost',
  //   'groundCost',
  //   'contingencyHoursAmount',
  //   'contingencyFuelAmount'
  // ];

  const {groundCostDetails: groundCostFilters} = costFilters;

  const newLegs = primaryLegs.map((leg) => ({ ...leg, groundCost: 0, groundCostDetails: [] }));
  for (let i = 0; i < newServices.length; i++) {
    for (let ii = 0; ii < newServices[i].costRecordAirports.length - 1; ii++) {
      const { airportCode: originAirportCode, totalOutboundCost, selected: outboundSelected } = newServices[i].costRecordAirports[ii];
      const { airportCode: destinationAirportCode, totalInboundCost, selected: inboundSelected } = newServices[i].costRecordAirports[ii + 1];

      const leg = __.find(newLegs, { originAirportCode, destinationAirportCode });

      let inboundfilter = true;
      let outboundfilter = true;

      const airportFilters = groundCostFilters?.airports || [];
      const airportFilterOut = ii < airportFilters.length ? airportFilters[ii] : null;
      if (airportFilterOut && __.has(airportFilterOut, newServices[i].costCategoryUuid)) {
        const serviceFilter = airportFilterOut[newServices[i].costCategoryUuid];
        if (serviceFilter) {
          outboundfilter = serviceFilter['out'];
        }
      }
      const airportFilterIn = (ii + 1) < airportFilters.length ? airportFilters[ii + 1] : null;
      if (airportFilterIn && __.has(airportFilterIn, newServices[i].costCategoryUuid)) {
        const serviceFilter = airportFilterIn[newServices[i].costCategoryUuid];
        if (serviceFilter) {
          inboundfilter = serviceFilter['in'];
        }
      }

      console.log(leg, originAirportCode, destinationAirportCode, totalOutboundCost, totalInboundCost, newServices[i].costCategoryName);

      if (leg) {
        if (totalInboundCost && inboundSelected && inboundfilter) {
          leg.groundCost += totalInboundCost;
          leg.groundCostDetails.push({ airportCode: destinationAirportCode, cost: totalInboundCost, serviceType: newServices[i].costCategoryName });
        }
        if (totalOutboundCost && outboundSelected && outboundfilter) {
          leg.groundCost += totalOutboundCost;
          leg.groundCostDetails.push({ airportCode: originAirportCode, cost: totalOutboundCost, serviceType: newServices[i].costCategoryName });
        }
      }
    }
  }

  newLegs.forEach((leg, i) => {
    leg = calculateLegsTotalCost(leg, i, costFilters);
    // leg.totalCost = 0;
    // let contingencyHoursAmount = Math.round((leg.acmiCost * 100 * ((contingencyBlockHoursRate||0) / 100)))/100;
    // let contingencyFuelAmount = Math.round((leg.fuelCost * 100 * ((contingencyFuelCostRate||0) / 100)))/100;

    // leg['contingencyHoursAmount'] = contingencyHoursAmount || 0;
    // leg['contingencyFuelAmount'] = contingencyFuelAmount || 0;

    // costTypes.forEach(field => {
    //   if (leg[field])
    //     leg.totalCost += leg[field];
    // });
  });
  return newLegs;
}

const rebuildLegCommissions = (primaryLegs, newCommissions) => {
  const newLegs = primaryLegs.map((leg) => ({ ...leg, commissionAmount: 0, commissionRevenuePercent: 0 }));

  for (let i = 0; i < newCommissions.length; i++) {
    const {originAirportCode, calculationMethod, totalAmount, unitAmount} = newCommissions[i];
    const leg = __.find(newLegs, {originAirportCode});
    if (leg) {
      if (calculationMethod === "PERCENT_OF_REVENUE") {
        leg.commissionRevenuePercent += (unitAmount||0);
      } else {
        leg.commissionAmount += (totalAmount||0);
      }
    }
  }
  return newLegs;
}

async function rebuildService(legs, costCategories, queryClient, services, aircraftReg, cargo, contingencyFuelCostRate, contingencyBlockHoursRate, overrides, costingDate, costFilters) {
  // const sectorLegs = Array.isArray(legs) ? legs.map((leg, i) => ({airportCode: leg.airprtCode, position: i, primary: leg.transportType === 'PRIMARY'})): [];

  const { sectorAirportsData, primaryLegs, otherLegs } = buildSectorsAirportData(legs);

  const newServices = [];

  const cargoData = getCargoData(legs, cargo);
  for (let ii = 0; ii < (costCategories?.data || []).length; ii++) {
    const category = costCategories.data[ii];
    const costRecordAirports = await Promise.all(sectorAirportsData.map((sector) => {
      return initialiseAirportCost(queryClient, category, services, aircraftReg, sector, cargoData, overrides, costingDate);
    }));

    newServices.push({
      costCategoryUuid: category.costCategoryUuid,
      costCategoryName: category.costCategoryName,
      costRecordAirports,
    });
  }

  const newLegs = rebuildLegTotals(primaryLegs, newServices, contingencyFuelCostRate, contingencyBlockHoursRate, costFilters);

  return {services: newServices, legs: [...newLegs, ...otherLegs]};
}

const getErrorClass = (checkAmount, errorType, costingErrors) => {
  if (!costingErrors || !Array.isArray(costingErrors.data)) {
    return "hasErrors"
  }    
  const errorRecord = __.find(costingErrors.data, {code: errorType});
  if (!errorRecord || !errorRecord.value || !errorRecord.value.amount) {
    return "hasErrors"
  }
  const {amount, toleranceUp, toleranceDown} = errorRecord.value;
  const min = amount - (amount * (toleranceDown / 100));
  const max = amount + (amount * (toleranceUp / 100));
  if (checkAmount < min || checkAmount > max) {
    return "hasErrors";
  }
  else return "";
}

const rebuildTotals = (legs, costingErrors, costFilters) => {
  
  const primaryLegs = __.filter(legs, {transportType: 'PRIMARY'});
  const truckLegs = __.filter(legs, {transportType: 'TRUCK'});
  const otherLegs = __.filter(legs, leg => leg.transportType !== 'PRIMARY' && leg.transportType !== 'TRUCK');

  const totals = {
    groundCosts: 0,
    totalBlockHours: 0,
    totalAcmiCost: 0,
    totalFuelBurn: 0,
    totalFuelCost: 0,
    totalOverflightCost: 0,
    totalSectorFlightCost: 0,    
    totalSaving: 0,
    averageBlockHours: 0,
    averageAcmiCost: 0,
    averageFuelBurn: 0,
    isAverageFuelBurnDiffer: 0,
    averageFuelPrice: 0,
    contingencyFuelCost: 0,
    contingencyBlockHours: 0,
    contingencyAcmiCost: 0,
    contingencySectorFlightCost: 0,
    overheads: 0,
    directCosts: 0,
    requiredRevenue: 0,
    profit: 0,
    totalRevenue: 0,
    grossMargin: 0,
    contribution: 0,    
    truckDistributionCosts: 0,
    otherFlightDistributionCosts: 0,
    totalCommissions: 0
  };

  const primaryLegTotals = {
    acmiCost: 'totalAcmiCost',
    groundCost: 'groundCosts',
    blockHours: 'totalBlockHours',
    fuelBurn: 'totalFuelBurn',
    fuelCost: 'totalFuelCost',
    overflightCost: 'totalOverflightCost',
    permitCosts: 'totalOverflightCost',
    sectorFlightCost: 'totalSectorFlightCost',
    saving: 'totalSaving',
    revenueAmount: 'totalRevenue',
    totalCost: 'requiredRevenue',
    contingencyFuelAmount: 'contingencyFuelCost',
    contingencyHoursAmount: 'contingencyAcmiCost',
  }

  const truckLegTotals = {
    revenueAmount: 'totalRevenue',
    totalCost: 'truckDistributionCosts',
  }

  const otherLegTotals = {
    revenueAmount: 'totalRevenue',
    totalCost: 'otherFlightDistributionCosts',
  }

  primaryLegs.forEach((leg, i) => {
    Object.entries(primaryLegTotals).forEach(([field, totalField]) => {
      const costType = getCostTypeForField(field);
      const {code, canEdit, extraFieldChecks} = costType || {};
      if (!costType || !canEdit || costFilters['flightCostDetails'][code][i] !== false) {
        if (extraFieldChecks) {
          const checkCode = extraFieldChecks[field];
          if (checkCode) {
            if (costFilters['flightCostDetails'][checkCode][i] === false) {
              return
            }
          }
        }
        if (leg[field] && !isNaN(leg[field])) totals[totalField] += leg[field];      
      } 
    });
    if (leg.commissionAmount && !isNaN(leg.commissionAmount)) {
      totals['totalCommissions'] += leg.commissionAmount;
    }
    if (leg.commissionRevenuePercent && !isNaN(leg.commissionRevenuePercent)) {
      totals['totalCommissions'] += (leg.revenueAmount * leg.commissionRevenuePercent / 100);
    }
  });
  
  truckLegs.forEach(leg => {
    Object.entries(truckLegTotals).forEach(([field, totalField]) => {
      if (leg[field] && !isNaN(leg[field])) totals[totalField] += leg[field];
    });
  })
  totals['requiredRevenue'] += totals.truckDistributionCosts;

  otherLegs.forEach(leg => {
    Object.entries(otherLegTotals).forEach(([field, totalField]) => {
      if (leg[field] && !isNaN(leg[field])) totals[totalField] += leg[field];
    });
  })

  // totals['contingencyAcmiCost'] = Math.round((totals.totalAcmiCost * 100 * ((contingencyBlockHoursRate||0) / 100)))/100;
  // totals['contingencyFuelCost'] = Math.round((totals.totalFuelCost * 100 * ((contingencyFuelCostRate||0) / 100)))/100;

  totals['requiredRevenue'] += totals.otherFlightDistributionCosts;
  totals['requiredRevenue'] += totals.totalCommissions;

  totals['contribution'] = totals.totalRevenue - totals.requiredRevenue;

  totals['averageBlockHours'] = Math.round((totals.totalBlockHours + totals.contingencyBlockHours / primaryLegs.length) * 100) / 100;
  totals['averageAcmiCost'] = Math.round((totals.totalAcmiCost + totals.contingencyAcmiCost) / primaryLegs.length);
  totals['averageFuelBurn'] = Math.round(totals.totalFuelBurn / totals.totalBlockHours);
  totals['isAverageFuelBurnDiffer'] = getErrorClass((totals.totalFuelBurn) / (totals.totalBlockHours + totals.contingencyBlockHours), 'AVERAGE FUEL BURN', costingErrors) === 'hasErrors';
  totals['averageFuelPrice'] = Math.round(((totals.totalFuelCost + totals.contingencyFuelCost) / totals.totalFuelBurn) * 100) / 100;

  return totals;
}

const calculateLegsTotalCost = (leg, legIndex, costFilters) => {
  const legFields = [
    'acmiCost',
    'fuelCost',
    'permitCosts',
    'overflightCost',
    'groundCost',
    'contingencyHoursAmount',
    'contingencyFuelAmount'
  ];

  let totalCost = 0;
  for (let i = 0; i < legFields.length; i++) {
    const field = legFields[i];
    const costType = getCostTypeForField(field);
    const {code, canEdit, extraFieldChecks} = costType || {};
//    debugger;
    if (!costType || !canEdit || costFilters['flightCostDetails'][code][legIndex] !== false) {
      if (extraFieldChecks) {
        const checkCode = extraFieldChecks[field];
        if (checkCode) {
          if (costFilters['flightCostDetails'][checkCode][legIndex] === false) {
            continue
          }
        }
      }
      if (leg[field] && !isNaN(leg[field])) totalCost += leg[field];      
    }
  }
  leg['totalCost'] = totalCost;
  return leg;
}

const queueSectorChanges = (changes, record, recordChange, eventBus, rebuildServicesQueue, processServicesRebuild, formId, costingErrors) => {
  // const {record, recordChange} = props;
  const {contingencyFuelCostRate, contingencyBlockHoursRate} = record;
  if (changes && changes.legs) {
    const oldLegs = record.legs;
    const oldLegList = Array.isArray(oldLegs) && oldLegs.length > 0?[oldLegs[0].originAirportCode, ...oldLegs.map(leg => leg.destinationAirportCode)]:[];

    const {legs, cargo} = rebuildPayloads(changes.legs, record.cargo);
    let services = __.cloneDeep(record?.services);
    const legsClone = __.cloneDeep(legs);
    rebuildServicesQueue.push({oldLegList, legs: legsClone, services, aircraftReg: record.aircraftReg, recordChange, cargo, contingencyFuelCostRate, contingencyBlockHoursRate, costingDate: record.costingDate, costFilters: record.costFilters});
    eventBus.trigger(`FormDialog.${formId}.changeRecord`, {changes: {legs, cargo}});
    if (changes.resolve) {
      changes.resolve();
    }  
    setTimeout(processServicesRebuild, 1);
  }
  if (changes && changes.leg) {
    const legs = record.legs;
    let performRebuild = false;
    for (let i = 0; i < legs.length; i++) {
      if (legs[i].costingSectorUuid === changes.leg?.costingSectorUuid) {
        const planData = __.pick(changes.leg, ['planText', 'planTankerText']);
        const legChanges = __.pick(changes.leg, [
          'fuelToUplift', 'tankeredExtraFuel', 'possibleTankerFuel', 'tankerFuelFactor', 'tankerCostPerUSG', 'dontTryTankering', 'fuelToCost', 'windData', 'blockHours', 
          'fuelBurn', 'fuelBurnKg', 'fod', 'overflightCost', 'acmiCost', 'fuelPolicyType', 'tanker', 'extraFuelCost', 'fuelCost', 'permitCosts', 'permitDetails', 'useTanker', 'jetPlanStatus', 'flightJetPlanUuid', 'optionRoute', 'optionRouteText',      
        ]);
        // console.log(JSON.stringify(legChanges));
        legs[i] = {...legs[i], planData, ...legChanges}
      }
      if (legs[i].acmiCost) {
        const leg = legs[i];
        let contingencyHoursAmount = Math.round((leg.acmiCost * 100 * ((contingencyBlockHoursRate||0) / 100)))/100;
        let contingencyFuelAmount = Math.round((leg.fuelCost * 100 * ((contingencyFuelCostRate||0) / 100)))/100;
    
        leg['contingencyHoursAmount'] = contingencyHoursAmount || 0;
        leg['contingencyFuelAmount'] = contingencyFuelAmount || 0;
             
        legs[i] = calculateLegsTotalCost(leg, i, record.costFilters);
        // const totalCost = legs[i].acmiCost + legs[i].fuelCost + legs[i].permitCosts + legs[i].overflightCost + legs[i].groundCost + legs[i].contingencyHoursAmount + legs[i].contingencyFuelAmount;
        // legs[i]['totalCost'] = totalCost;  
        performRebuild = true;
      } 
    }
    if (performRebuild) {
      const revisedLegs = rebuildRevenue(legs, contingencyBlockHoursRate); 
      const totals = rebuildTotals(revisedLegs, costingErrors, record.costFilters);
      eventBus.trigger(`FormDialog.${formId}.changeRecord`, {changes: {legs: revisedLegs, ...totals}});
    } else {
      eventBus.trigger(`FormDialog.${formId}.changeRecord`, {changes: {legs: legs}});
    }
  }
}

const handleServicesChanged = (changes, props) => {

  if (changes && changes.costingErrors) {
    const {record, recordChange} = props;
    const services = changes?.services || record?.services;
    const costFilters = changes?.costFilters || record?.costFilters;
    const newLegs = rebuildLegTotals(record?.legs, services, record.contingencyFuelCostRate, record.contingencyBlockHoursRate, costFilters);
    const revisedLegs = rebuildRevenue(newLegs, record?.contingencyBlockHoursRate); 
    const totals = rebuildTotals(revisedLegs, changes.costingErrors, costFilters);
    recordChange({...changes, legs:revisedLegs, ...totals});
  }
}

const handleCommissionsChanged = (changes, props) => {
  try {
    if (changes && changes.commissions) {
      const {record, recordChange} = props;
      const newLegs = rebuildLegCommissions(record?.legs, changes.commissions);
      const revisedLegs = rebuildRevenue(newLegs, record?.contingencyBlockHoursRate); 
      const totals = rebuildTotals(revisedLegs, changes.costingErrors, record.costFilters);
      recordChange({commissions: changes.commissions, legs:revisedLegs, ...totals});
      if (changes.resolve) changes.resolve();
    } else {
      if (changes.reject) changes.reject();
    }  
  } catch(err) {
    if (changes.reject) changes.reject();
  }
}

const handleFlightCostsChanged = (params, props) => {
  try {
    const {changes, costingErrors} = params;
    if (changes) {
      const {record, recordChange} = props;
      const legs = record?.legs || [];
      const sectors = __.filter(legs, {transportType: 'PRIMARY'});
    
      const costFilters = {...record.costFilters, ...changes};
      // const totals = rebuildTotals(record?.legs, costingErrors, costFilters);

      // const sectorTotals = getGrandTotals(sectors, costTypes, costFilters);
      for(let i = 0; i < sectors.length; i++) {
        const leg = calculateLegsTotalCost(sectors[i], i, costFilters);
        sectors[i] = leg;
        // const sectorTotal = sectorTotals[i];
        // sectors[i].totalCost = sectorTotal;
      }     

      const newLegs = rebuildLegCommissions(record?.legs, record?.commissions);
      const revisedLegs = rebuildRevenue(newLegs, record?.contingencyBlockHoursRate); 
      const totals = rebuildTotals(revisedLegs, costingErrors, costFilters);
      recordChange({costFilters, commissions: record.commissions, legs:revisedLegs, ...totals});
      // recordChange({costFilters});
      // recordChange({costFilters, ...totals});
      if (params.resolve) params.resolve();
    } else {
      if (params.reject) params.reject();
    }  
  } catch(err) {
    if (params.reject) params.reject();
  }
}

const buildLegsFromSuggestion = async (option, queryClient, record) => {
  const {combination} = option;
  const legs = [];
  const {costingDate} = record;
  for (let i = 0; i < combination.length - 1; i++) {

    const fuelRecord = await fetchCostingFuelRate({queryClient, extraKeys:[combination[i], costingDate], useCache: true});
    let originFuelRecord = {success: false, error: fuelRecord.error};
    let fuelPrice = null;
    if (fuelRecord && fuelRecord.success && fuelRecord.rateRecord) {
      const {rate} = fuelRecord.rateRecord;
      fuelPrice = rate;
      originFuelRecord = {...fuelRecord.rateRecord, success: true};
    }

    const airport = await fetchAirport({queryClient, extraKeys: [combination[i + 1]], useCache: true});
    const destinationAirport = Array.isArray(airport) && airport.length > 0?airport[0]:null;

    legs.push({
      costingSectorUuid: uuidv4(),
      originAirportCode: combination[i],
      destinationAirportCode: combination[i + 1],
      alternateAirportCode: destinationAirport?.alternateAirportCode,
      alternateAirportIcaoCode: destinationAirport?.alternateAirportIcaoCode,
      transportType: 'PRIMARY',
      legType: 'CHARTER',
      fuelPrice,   
      originFuelRecord,   
      revenueCalculationMethod: record.revenueCalculationMethod, 
      revenueCalculationAmount: 0,
      flightJetPlanUuid: null,
      fuelPolicyType: "",
      planData: null, 
    });

  }

  return legs
}

const runSectorJetPlan = async (record, sector, apiSitePrefix) => {
  const {originAirportCode, destinationAirportCode, costingSectorUuid, payloadOnboard, alternateAirportCode, fuelPrice, flightJetPlanUuid} = sector;
  const {aircraftReg, routeWinds, routeWindsMonth, costingDate} = record;

  await axios.put(`${apiSitePrefix}/costings/runsectorjetplan/`, {
    sector: {
      aircraftReg, routeWinds, routeWindsMonth, costingDate,
      originAirportCode, destinationAirportCode, costingSectorUuid, payloadOnboard, alternateAirportCode, fuelPrice, flightJetPlanUuid
    }
  });
}

const getCosting = async (costingUuid, apiSitePrefix, SystemData) => {
  try {
    const response = await axios.get(`${apiSitePrefix}/costings/list/${costingUuid}`);
    if (response.data && Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }

    if (!response.data) {
      const message = `Could not retrieve Costing. Server is not responding`;
      console.log(message);
      SystemData.alert("Error", message);
    } else if (!Array.isArray(response.data) || response.data.length < 1) {
      const message = `Could not retrieve Costing. Costing data not found`;
      console.log(message);
      SystemData.alert("Error", message);
    }
  } catch (err) {
    const message = `Could not retrieve Costing. Server is not responding`;
    console.log(message);
    SystemData.alert("Error", message);
  }

  return null;
}

const getCostingByUcn = async (costingNumber, apiSitePrefix, SystemData) => {
  try {
    const response = await axios.get(`${apiSitePrefix}/costings/getByUcn/${costingNumber}`);
    if (response.data && Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }

    if (!response.data) {
      const message = `Could not retrieve Costing by UCN. Server is not responding`;
      console.log(message);
      SystemData.alert("Error", message);
    } else if (!Array.isArray(response.data) || response.data.length < 1) {
      const message = `Could not retrieve Costing by UCN. Costing data not found`;
      console.log(message);
      SystemData.alert("Error", message);
    }
  } catch (err) {
    const message = `Could not retrieve Costing by UCN. Server is not responding`;
    console.log(message);
    SystemData.alert("Error", message);
  }

  return null;
}

const getCostingDefaultValues = async (apiSitePrefix, SystemData, callBack) => {
  try {
    const response = await axios.get(`${apiSitePrefix}/costings/defaults`);
    if (response.data && response.data.success) {
      if (callBack && typeof callBack === 'function') callBack(response.data.defaultValues);
      return response.data.defaultValues;
    }

    if (!response.data) {
      console.log(`Could not retrieve Costing Defaults. Server is not responding`);
      SystemData.alert("Error", `Could not retrieve Defaults. Server is not responding`);
    } else if (!response.data.success) {
      console.log(`Could not retrieve Costing Defaults. Server returned ${response.data.error}`);
      SystemData.alert("Error", `Could not retrieve Defaults. Server returned ${response.data.error}`);
    }
  } catch (err) {
    console.log(`Could not retrieve Costing Defaults. Server is not responding`);
    SystemData.alert("Error", `Could not retrieve Defaults. Server is not responding`);
  }
}

const populateCostFilters = (record, costCategories) => {
  const {legs} = record;
  const costFilters = record?.costFilters||{...defaultCostFilters};
  if (!__.has(costFilters['groundCostDetails'], 'categoryGroups')) costFilters['groundCostDetails']['categoryGroups'] = {};
  if (!__.has(costFilters['groundCostDetails'], 'categories')) costFilters['groundCostDetails']['categories'] = {};
  if (!__.has(costFilters['groundCostDetails'], 'airports')) costFilters['groundCostDetails']['airports'] = [];
  costCategories.data.forEach(category => {
    let {costCategoryUuid, costingGroupUuid} = category;
    if (!__.has(costFilters['groundCostDetails']['categoryGroups'], costingGroupUuid)) costFilters['groundCostDetails']['categoryGroups'][costingGroupUuid] = true;
    if (!__.has(costFilters['groundCostDetails']['categories'], costCategoryUuid)) costFilters['groundCostDetails']['categories'][costCategoryUuid] = true;
  });

  const FlightSectors = [];
  const flightCostDetails = __.cloneDeep(defaultCostFilters['flightCostDetails']);
  for (let i = 0; i < legs.length; i++) {
    if (costFilters['FlightSectors'].length>i) {
      FlightSectors.push(costFilters['FlightSectors'][i]);
    } else {
      FlightSectors.push(true);
    }
    for (const code in flightCostDetails) {
      if (__.has(costFilters['flightCostDetails'], code) && costFilters['flightCostDetails'][code].length>i) {
        flightCostDetails[code].push(costFilters['flightCostDetails'][code][i]);
      } else {
        flightCostDetails[code].push(true);
      }
    }
  }
  const airportFilters = [];
  if (legs.length > 0) {
    const leg = legs[0];
    const {originAirportCode} = leg;
    let airportFilter = {airportCode: originAirportCode, out: true, in: true };
    if (costFilters['groundCostDetails']['airports'].length>0 && costFilters['groundCostDetails']['airports'][0].airportCode === originAirportCode) {
      airportFilter = {...airportFilter, ...costFilters['groundCostDetails']['airports'][0]};
    }
    costCategories.data.forEach(category => {
      let {costCategoryUuid} = category;
      if (!__.has(airportFilter, costCategoryUuid)) airportFilter[costCategoryUuid] = {out: true, in: true};
    });
    airportFilters.push(airportFilter);
  }
  for (let i = 0; i < legs.length; i++) {
    const leg = legs[i];
    const {destinationAirportCode} = leg;
    let airportFilter = {airportCode: destinationAirportCode, out: true, in: true };
    if (costFilters['groundCostDetails']['airports'].length>(i + 1) && costFilters['groundCostDetails']['airports'][i + 1].airportCode === destinationAirportCode) {
      airportFilter = {...airportFilter, ...costFilters['groundCostDetails']['airports'][i + 1]};
    }
    costCategories.data.forEach(category => {
      let {costCategoryUuid} = category;
      if (!__.has(airportFilter, costCategoryUuid)) airportFilter[costCategoryUuid] = {out: true, in: true};
    });
    airportFilters.push(airportFilter);
  }
  costFilters['groundCostDetails']['airports'] = airportFilters;
  costFilters['FlightSectors'] = FlightSectors;
  costFilters['flightCostDetails'] = flightCostDetails;
  console.log('Cost Filters', costFilters);
  return costFilters;
}

export {
  checkDate,
  checkCargoHandling,
  calculateLineCost,
  initialiseAirportCost,
  rebuildPayloads,
  rebuildService,
  getErrorClass,
  rebuildTotals,
  buildLegsFromSuggestion,
  calculateRevenue,
  rebuildRevenue,
  runSectorJetPlan,
  buildSectorsAirportData,
  getCargoData,
  rebuildLegTotals,
  getCosting,
  getCostingByUcn,
  getCostingDefaultValues,
  rebuildLegCommissions,
  handleServicesChanged,
  handleCommissionsChanged,
  queueSectorChanges,
  handleFlightCostsChanged,
  costTypes,
  defaultCostFilters,
  populateCostFilters,
  totalFields,
  getGrandTotals,
}

